import { useQuery } from "@tanstack/react-query";
import { getCustomerActivity } from "../../api/bReviewsApi";

export const useCustomerActivity = (params, enabled = true) => useQuery({
  queryKey: ["customer-activity", params],
  queryFn: () => getCustomerActivity(params),
  enabled: Boolean(params?.organisationId && params?.startDate && params?.endDate && enabled),
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: true,
});
